import { render, staticRenderFns } from "./client-resources.vue?vue&type=template&id=0849ab62&scoped=true"
import script from "./client-resources.vue?vue&type=script&lang=js"
export * from "./client-resources.vue?vue&type=script&lang=js"
import style0 from "./client-resources.vue?vue&type=style&index=0&id=0849ab62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849ab62",
  null
  
)

export default component.exports